import { t } from 'i18next';

import type { Publication } from '~/interfaces/publication';

import Logo from '../Logo';
import Text from '../Text';

interface Props {
  publication: Publication;
}

const PoweredByBeehiiv = ({ publication }: Props) => {
  if (!publication.beehiiv_branding) return null;

  return (
    <div className="w-fit">
      <Text as="span" theme="default">
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://www.beehiiv.com/?utm_source=${publication.name}&utm_medium=footer`}
          className="extra-light flex items-center rounded border border-gray-300 bg-white px-3 py-2 text-xs"
        >
          <Logo className="mr-2 h-4 w-4" />
          <Text as="span" theme="default">
            {t('shared.cta.powered_by_beehiiv') || 'Powered by beehiiv'}
          </Text>
        </a>
      </Text>
    </div>
  );
};

export default PoweredByBeehiiv;
